/**
 * @generated SignedSource<<713fcea4d9381f60a964fe2af4af2142>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamMemberResendInvitationMutation$variables = {
  id: string;
};
export type teamMemberResendInvitationMutation$data = {
  readonly resendTeamMemberInvitation: {
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberInvitationFragment">;
  };
};
export type teamMemberResendInvitationMutation = {
  variables: teamMemberResendInvitationMutation$variables;
  response: teamMemberResendInvitationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "teamMemberResendInvitationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamMemberInvitation",
        "kind": "LinkedField",
        "name": "resendTeamMemberInvitation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "teamMemberInvitationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "teamMemberResendInvitationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamMemberInvitation",
        "kind": "LinkedField",
        "name": "resendTeamMemberInvitation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "platformAccess",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "memberUserProfile",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accepted",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "createdByUserProfile",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3a66a3027e2899f25963d93451c84d7",
    "id": null,
    "metadata": {},
    "name": "teamMemberResendInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation teamMemberResendInvitationMutation(\n  $id: ID!\n) {\n  resendTeamMemberInvitation(id: $id) {\n    ...teamMemberInvitationFragment\n    id\n  }\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment teamMemberInvitationFragment on TeamMemberInvitation {\n  id\n  externalRef\n  accountId\n  account {\n    ...accountBaseFragment\n    id\n  }\n  memberUserId\n  memberUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n  email\n  message\n  accepted\n  createdAt\n  createdByUserProfile {\n    ...teamMemberUserProfileFragment\n    id\n  }\n}\n\nfragment teamMemberUserProfileFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "ebde0f5b5481d85f514cb8974be57587";

export default node;
